"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * DataProvider acting as translator between input data and the internal data representation.
 */
var DataProvider = /** @class */ (function () {
    function DataProvider(parsers) {
        this._parsers = parsers;
        if (this._parsers.length === 0) {
            new Console().error('The DataProvider was instanciated with an empty "parsers" configuration. ' +
                'The data import will not work - was this intentionally?');
        }
    }
    /**
     * Imports the given data and transforms it into the internal data structure. Therefore an appropriate parser is
     * detected by the given format.
     *
     * @param inputData
     * @param format
     */
    DataProvider.prototype.importData = function (inputData, format) {
        var parserInstance;
        parserInstance = this.getMatchingParser(format);
        var internalDataPromise = parserInstance.readData(inputData);
        return internalDataPromise;
    };
    /**
     * Returns the correct parser for the given format (or undefined).
     */
    DataProvider.prototype.getMatchingParser = function (format) {
        var prsr;
        this.parsers.forEach(function (parser) {
            if (parser.format.toLowerCase === format.toLowerCase) {
                prsr = parser.instance;
            }
        });
        return prsr;
    };
    Object.defineProperty(DataProvider.prototype, "parsers", {
        /**
         * Getter parsers
         * @return {ParserDesc[]}
         */
        get: function () {
            return this._parsers;
        },
        /**
         * Setter parsers
         * @param {ParserDesc[]} value
         */
        set: function (value) {
            this._parsers = value;
        },
        enumerable: true,
        configurable: true
    });
    return DataProvider;
}());
exports.default = DataProvider;
//# sourceMappingURL=DataProvider.js.map